
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { EventStatus as EventStatusEnum } from '@/services/eventService';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { EventFormValues } from '../schemas/eventFormSchema';
import StatusBadge from '../StatusBadge';

interface EventStatusProps {
  form: ReturnType<typeof useFormContext<EventFormValues>>;
}

// Define the allowed statuses for the form (excluding CANCELLED and POSTPONED)
const allowedStatuses = {
  [EventStatusEnum.DRAFT]: 'Vázlat',
  [EventStatusEnum.PUBLISHED]: 'Közzétéve',
  [EventStatusEnum.ARCHIVED]: 'Archiválva',
};

const EventStatus: React.FC<EventStatusProps> = ({ form }) => {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg">Esemény státusz</CardTitle>
      </CardHeader>
      <CardContent>
        <FormField
          control={form.control}
          name="status"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Státusz</FormLabel>
              <div className="flex items-center gap-3">
                <FormControl>
                  <Select 
                    value={field.value ?? EventStatusEnum.DRAFT} 
                    onValueChange={(value) => field.onChange(value)}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Válasszon státuszt" />
                    </SelectTrigger>
                    <SelectContent>
                      {Object.entries(allowedStatuses).map(([value, label]) => (
                        <SelectItem key={value} value={value}>
                          {label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </FormControl>
                <StatusBadge status={field.value as EventStatusEnum ?? EventStatusEnum.DRAFT} />
              </div>
              <FormMessage />
            </FormItem>
          )}
        />
      </CardContent>
    </Card>
  );
};

export default EventStatus;
